import React from "react";
const SvgMapToolsClose = props => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#MapToolsClose_svg__MapToolsClose_svg__clip0_2709_46423)">
      <path
        fill="#000"
        fillRule="evenodd"
        d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="MapToolsClose_svg__MapToolsClose_svg__clip0_2709_46423">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMapToolsClose;
